import { createElement } from "react";
import type { ReactElement } from "react";
import { htmlFallbackProps } from "./element";
import { RAW_MARKUP_ATTRIBUTE } from "./raw-markup";

/** Re-emit a preserved element, with the children ProseMirror parsed into it. */
export function htmlFallbackEmailRenderer(attrs: Record<string, unknown>, children?: ReactElement) {
  const tag = attrs.tag as string || "div";
  return createElement(tag, htmlFallbackProps(attrs), children);
}

/**
 * A synthetic wrapper — ProseMirror needed a node to hold loose text and this
 * one carries no tag of its own. Emitting a `<div>` here would invent a line
 * break the source never had, so the children go out bare.
 */
export function htmlTextEmailRenderer(attrs: Record<string, unknown>, children?: ReactElement) {
  if (!attrs.tag) return <>{children}</>;
  return htmlFallbackEmailRenderer(attrs, children);
}

/**
 * Markup React has no way to emit — see `raw-markup.ts`. The placeholder is
 * swapped back for the original bytes once the tree is a string.
 */
export function htmlRawEmailRenderer(attrs: Record<string, unknown>) {
  return <span {...{
    [RAW_MARKUP_ATTRIBUTE]: attrs.html as string ?? ""
  }} />;
}